/**
 * Matrix JS SDK cancels in-flight HTTP (e.g. /sync) with AbortController when the
 * client stops or remounts. Those rejections are expected; suppress dev overlay noise.
 */
import { isAbortError } from './shared/utils/isAbortError';

if (typeof window !== 'undefined') {
  const onUnhandledRejection = (event) => {
    if (isAbortError(event?.reason)) {
      try {
        event.preventDefault();
        event.stopImmediatePropagation();
      } catch (_) {}
    }
  };

  window.addEventListener('unhandledrejection', onUnhandledRejection, { capture: true });
}
